import { Col, Form, Input, DatePicker, TimePicker, Row } from 'antd';
import React, { useEffect } from 'react';
import moment from 'moment';
import { CollectionStatus, IAdminCollection } from '../../../app/models/Collection';

interface IProps {
	collection: Partial<IAdminCollection>;
	setCollection: (collection: Partial<IAdminCollection>) => void;
}

const CollectionPodFormComponent: React.FC<IProps> = ({
	collection,
	setCollection
}) => {
	const setSigneeFullName = (value: string) => {
		setCollection({ ...collection, signeeFullName: value });
	};

	const setPickupDate = (value: moment.Moment | null) => {
		if (value) {
			const date = value.toDate();
			// If there's already a time, preserve it
			if (collection.pickupDateTime) {
				date.setHours(collection.pickupDateTime.getHours());
				date.setMinutes(collection.pickupDateTime.getMinutes());
			}
			setCollection({ ...collection, pickupDateTime: date });
		} else {
			setCollection({ ...collection, pickupDateTime: undefined });
		}
	};

	const setDeliveryDate = (value: moment.Moment | null) => {
		if (value) {
			const date = value.toDate();
			// If there's already a time, preserve it
			if (collection.deliveryDateTime) {
				date.setHours(collection.deliveryDateTime.getHours());
				date.setMinutes(collection.deliveryDateTime.getMinutes());
			}
			setCollection({ ...collection, deliveryDateTime: date });
		} else {
			setCollection({ ...collection, deliveryDateTime: undefined });
		}
	};

	const setDeliveryTime = (value: moment.Moment | null) => {
		if (value && collection.deliveryDateTime) {
			const date = new Date(collection.deliveryDateTime);
			date.setHours(value.hours());
			date.setMinutes(value.minutes());
			setCollection({ ...collection, deliveryDateTime: date });
		} else if (value && !collection.deliveryDateTime) {
			const date = new Date();
			date.setHours(value.hours());
			date.setMinutes(value.minutes());
			date.setSeconds(0);
			date.setMilliseconds(0);
			setCollection({ ...collection, deliveryDateTime: date });
		}
	};

	useEffect(() => {
		if (!collection.pickupDateTime) {
			setCollection({...collection, pickupDateTime: collection.readyDate})
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// Only show the POD form if the collection status is "Completed"
	if (collection.status !== CollectionStatus.Completed && collection.status !== CollectionStatus.Delivered) {
		return null;
	}

	return (
		<>
			<div style={{border: '2px solid black', padding: '0 6px', borderRadius: '5px'}} id="CustomCollectionPodFormComponentContainer">
					<Form layout={'vertical'}>
						<Form.Item label={'Recipient Name'}>
							<Input
								autoComplete="off"
								defaultValue={collection.signeeFullName}
								onChange={(value) => setSigneeFullName(value.target.value)}
							/>
						</Form.Item>
						<Row gutter={16}>
							<Col span={12}>
								<Form.Item label={'Collection Date'}>
									<DatePicker
										defaultValue={collection.pickupDateTime ? moment(collection.pickupDateTime) : moment(collection.readyDate)}
										onChange={setPickupDate}
										getPopupContainer={() =>
											document.getElementById(
												'CustomCollectionPodFormComponentContainer'
											)!
										}
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col span={12}>
								<Form.Item label={'Delivery Date'}>
									<DatePicker
										defaultValue={collection.deliveryDateTime ? moment(collection.deliveryDateTime) : undefined}
										onChange={setDeliveryDate}
										getPopupContainer={() =>
											document.getElementById(
												'CustomCollectionPodFormComponentContainer'
											)!
										}
									/>
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item label={'Delivery Time'}>
									<TimePicker
										defaultValue={collection.deliveryDateTime ? moment(collection.deliveryDateTime) : undefined}
										onChange={setDeliveryTime}
										getPopupContainer={() =>
											document.getElementById(
												'CustomCollectionPodFormComponentContainer'
											)!
										}
										format="HH:mm"
									/>
								</Form.Item>
							</Col>
						</Row>
					</Form>
			</div>
		</>
	);
};

export default CollectionPodFormComponent;